import Reveal from "./Reveal";
import { SectionHeading } from "./SectionHeading";

const GOOGLE_TAGS = [
    "Search campaigns",
    "Keyword strategy",
    "Ad copy",
    "Geographic targeting",
    "Bid optimization",
    "Ongoing campaign management",
];

const META_TAGS = [
    "Meta campaign strategy",
    "Lead generation",
    "Retargeting",
    "Creative testing",
    "Audience targeting",
];

const TRACKING_TAGS = [
    "Google Tag",
    "Google Analytics 4",
    "Google Ads conversion tracking",
    "Form submissions",
    "Calendly/booking conversions",
    "Cross-channel measurement",
];

const TagList = ({ tags }) => (
    <ul className="flex flex-wrap gap-2 mt-8" aria-label="Included services">
        {tags.map((t) => (
            <li
                key={t}
                className="text-xs text-zinc-400 border border-white/10 px-3 py-1.5 tracking-wide"
            >
                {t}
            </li>
        ))}
    </ul>
);

export const Services = () => (
    <section
        id="services"
        className="py-24 md:py-32 lg:py-40 bg-ink-800/40 border-y border-white/5"
    >
        <div className="shell">
            <SectionHeading
                eyebrow="Services"
                title="Paid acquisition built around performance."
            />
            <div className="mt-16 md:mt-20 grid lg:grid-cols-3 gap-6">
                <Reveal className="lg:col-span-3 h-full">
                    <article
                        data-testid="service-card-google-ads"
                        className="h-full border border-brass-500/40 bg-ink-900 p-8 md:p-12 transition-colors duration-300 hover:border-brass-500/70"
                    >
                        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16">
                            <div>
                                <div className="flex items-center gap-4">
                                    <span className="font-serif italic text-5xl text-brass-500/40">
                                        01
                                    </span>
                                    <span className="text-[11px] uppercase tracking-[0.22em] font-semibold text-brass-400 border border-brass-500/40 px-3 py-1.5">
                                        Primary Service
                                    </span>
                                </div>
                                <h3 className="mt-7 font-serif text-3xl md:text-4xl text-white">
                                    Google Ads
                                </h3>
                                <p className="mt-3 text-brass-400 font-medium">
                                    Capture high-intent demand.
                                </p>
                                <p className="mt-4 text-base leading-relaxed text-zinc-400 max-w-md">
                                    Reach prospective clients who are actively
                                    searching Google for legal services.
                                </p>
                            </div>
                            <div className="self-center">
                                <TagList tags={GOOGLE_TAGS} />
                            </div>
                        </div>
                    </article>
                </Reveal>

                <Reveal delay={0.08} className="h-full">
                    <article
                        data-testid="service-card-meta-ads"
                        className="h-full border border-white/10 bg-ink-900 p-8 md:p-10 transition-colors duration-300 hover:border-brass-500/50"
                    >
                        <span className="font-serif italic text-5xl text-brass-500/40">
                            02
                        </span>
                        <h3 className="mt-6 font-serif text-2xl text-white">
                            Meta Ads
                        </h3>
                        <p className="mt-2 text-brass-400 font-medium text-sm">
                            Create demand and stay top of mind.
                        </p>
                        <p className="mt-4 text-sm leading-relaxed text-zinc-400">
                            Use Facebook and Instagram advertising to build
                            awareness, reach relevant audiences, and retarget
                            prospective clients who have interacted with the
                            firm's website or advertising.
                        </p>
                        <p className="mt-4 text-sm italic text-zinc-500">
                            Complements high-intent search. It does not replace it.
                        </p>
                        <TagList tags={META_TAGS} />
                    </article>
                </Reveal>

                <Reveal delay={0.16} className="h-full">
                    <article
                        data-testid="service-card-conversion-tracking"
                        className="h-full border border-white/10 bg-ink-900 p-8 md:p-10 transition-colors duration-300 hover:border-brass-500/50"
                    >
                        <span className="font-serif italic text-5xl text-brass-500/40">
                            03
                        </span>
                        <h3 className="mt-6 font-serif text-2xl text-white">
                            Conversion Tracking
                        </h3>
                        <p className="mt-2 text-brass-400 font-medium text-sm">
                            Know what is actually working.
                        </p>
                        <p className="mt-4 text-sm leading-relaxed text-zinc-400">
                            Track the journey from advertisement to lead,
                            consultation request, or booking.
                        </p>
                        <TagList tags={TRACKING_TAGS} />
                    </article>
                </Reveal>

                <Reveal delay={0.24} className="h-full">
                    <article
                        data-testid="service-card-landing-pages"
                        className="h-full border border-white/10 bg-ink-900 p-8 md:p-10 transition-colors duration-300 hover:border-brass-500/50"
                    >
                        <span className="font-serif italic text-5xl text-brass-500/40">
                            04
                        </span>
                        <h3 className="mt-6 font-serif text-2xl text-white">
                            Landing Pages
                        </h3>
                        <p className="mt-2 text-brass-400 font-medium text-sm">
                            Turn clicks into opportunities.
                        </p>
                        <p className="mt-4 text-sm leading-relaxed text-zinc-400">
                            Create focused landing experiences designed around
                            one objective: converting relevant paid traffic
                            into qualified inquiries.
                        </p>
                    </article>
                </Reveal>
            </div>
        </div>
    </section>
);

export default Services;
